import {ServiceGlobal} from './service.global';
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/toPromise';
import {API} from '../../config/api';
import {ActivitiesFile, ActivitiesModel} from '../../application/web-components/student/activities.model';


@Injectable()
export class ActivitiesService extends ServiceGlobal {
    activity_id: any;
    createddate: any;
    lastmoddate: any;
    group_id: any;
    start_time: any;
    end_time: any;
    duration: any;
    date: Date = new Date();
    objective: any;
    type: any;
    remarks: any;
    mentor: any;
    document_name: any;
    document_type: any;
    document: any;
    activity_files: any;
    activity_mentors: any;
    group: any;
    student_id: any;
    group_time_slot: string = null;
    contact_means: string;

    name_alpha: any = 'display_name';
    api_find_all: any = 'activities';
    api_find_one: any = 'activities';
    api_delete: any  = 'activities';
    loading: any = false;
    primary_key: any = 'activity_id';
    tableName() { return 'activities'; }
    
    public objectives = {
      mentoring: 'Mentoring',
      teaching: 'Teaching',
      tutoring: 'Tutoring',
      skill_training: 'Skill training'
    }
  
    public types = {
      integrated_tasks: 'Integrated task',
      structured_discussions: 'Structured discussions',
      chatting: 'Chatting',
      personal_discussions: 'Personal discussions',
      group_games: 'Group games',
      lecture_ppt: 'Lecture ppt',
      others: 'Others',
      video_movie: 'Video movie'
    }

    attributeLabels() {
        return Object.assign(super.attributeLabels(), {
            "activity_id": "activity_id",
            "group_time_slot": "Timeslot",
            "group_id": "group_id",
            'student_id': 'student_id',
            "date": "Activity Date",
            "activity_date": "Activity Date",
            "activity_start_time": "Start Time",
            "activity_end_time": "End Time",
            "activity_duration": "Time Spent",
            "start_time": "Start Time",
            "end_time": "End Time",
            "duration": "Time Spent",
            "objective": "Activity Objective",
            "type": "Activity Type",
           "activity_type": "Activity Type",
            "remarks": "Remarks",
            "activity_remarks": "Remarks",
            "mentor": "Mentor",
            "document_name": "Document Name",
            "document_type": "Document Type",
            "contact_means": "Contact Means",
            "document": ' ',
            "activity_files": " ",
            "group": "",
            'student': '',
        });
    }

    rule() {
        return Object.assign(super.rule(), {
            "group_id": {
                "type": "string",
            },
            'student_id': {
                'type': 'string',
            },
            "date": {
                "type": "date",
                "require": {
                  "empty": true,
                  "date": true,
                },
            },
            "start_time": {
                "type": "date",
              "require": {
                "empty": true,
              },
            },
            "group_time_slot": {
              "type": "string",
              "size": 255
            },
            "end_time": {
                "type": "date",
                "require": {
                  "empty": true,
                },
            },
            "type": {
                "type": "string",
                "require": {
                  "empty": true,
                },
            },
            "objective": {
              "type": "string",
              "require": {
                "empty": true,
              },
            },
            "remarks": {
                "type": "string",
            },
            "mentor": {
                "type": "string",

            },
            "activity_files": {
                "type": "any",
            },
            "group": {
                "type": "any",
            },
            "student": {
                "type": "any",
            },
            "document_name": {
                "type": "any"
            },
            "contact_means": {
                "type": "string",
                "require": {
                  "empty": true,
                },
            }

        });
    }

    save(update = false, oldMentor: any = '') {

        var link = API.CREATE_ACTIVITIES;
        let attrs = this.getAttributes();
        let tmp = attrs['date'];
        attrs['date'] = new Date(tmp).getTime();
        let startDateTime =  new Date(tmp);
        startDateTime.setHours(attrs['start_time'].split(':')[0], attrs['start_time'].split(':')[1]);
        attrs['start_time'] = startDateTime.getTime();
        let endDateTime =  new Date(tmp);
        endDateTime.setHours(attrs['end_time'].split(':')[0], attrs['end_time'].split(':')[1]);
        attrs['end_time'] = endDateTime.getTime();
        attrs['activity_mentors'] = [{"mentor": attrs['mentor']}];

        let file = attrs['document'];
        if (file) {
            let filename = attrs['document_name'];
            if (typeof file !== 'string' && !(file instanceof String)) {
              file.name = filename;
            }
            attrs['activity_files'] = [{
                file: file,
                type: attrs['document_type'],
                remarks: filename
            }];
        } else {
            attrs['activity_files'] = [];
        }

        attrs['mentor'] = undefined;
        attrs['document'] = undefined;
        attrs['document_type'] = undefined;
        attrs['document_name'] = undefined;
        attrs['academic_year'] = undefined;

        if (update) {
            link += '/' + encodeURIComponent(attrs['activity_id']);
            if (file && file.url) {
                link += '?' +
                        encodeURIComponent('$expand') +
                        '=' +
                        encodeURIComponent('activity_files/file');
            }
            let changeMentor = false;
            if (oldMentor != attrs['activity_mentors'][0].mentor) {
              changeMentor = true;
            }

            if (!changeMentor) {
              attrs['activity_mentors'] = undefined;
            }
            return this._db.post(link, attrs);
        }
        return this._db.post(link, attrs);
    }

  addIndividualActivity(update, linkCreate, linkUpdate) {
    let attrs = this.getAttributes();
    let activitiesDto: ActivitiesModel = new ActivitiesModel();

    let tmp = attrs['date'];
    activitiesDto.student_id = attrs['student'];
    activitiesDto.group_time_slot = attrs['group_time_slot'];
    let startDateTime =  new Date(tmp);
    startDateTime.setHours(attrs['start_time'].split(':')[0], attrs['start_time'].split(':')[1]);
    attrs['start_time'] = startDateTime.getTime();
    let endDateTime =  new Date(tmp);
    endDateTime.setHours(attrs['end_time'].split(':')[0], attrs['end_time'].split(':')[1]);
    attrs['end_time'] = endDateTime.getTime();

    activitiesDto.activity_date = new Date(tmp).getTime();
    activitiesDto.activity_start_time = startDateTime.getTime();
    activitiesDto.activity_end_time = endDateTime.getTime();
    activitiesDto.activity_objective = attrs['objective'];
    activitiesDto.activity_remarks = attrs['remarks'];
    activitiesDto.activity_duration = attrs['duration'];
    activitiesDto.activity_type = attrs['type'];
    activitiesDto.contact_means = attrs['contact_means'];

    attrs['date'] = new Date(tmp).getTime();
    attrs['start_time'] = startDateTime.getTime();
    attrs['end_time'] = endDateTime.getTime();

    if (attrs['document']) {
      let activitiesFile = new ActivitiesFile();
      activitiesFile.file = attrs['document'];
      activitiesFile.type = attrs['document_type'];
      activitiesFile.remarks = attrs['document_name'];
      activitiesDto.activity_files.push(activitiesFile);

      attrs['activity_files'] = [{
        "file": attrs['document'],
        "type": attrs['document_type'],
        "remarks": attrs['document_name']
      }];

    } else {
      activitiesDto.activity_files = null;
    }

    activitiesDto.group_files = null;
    attrs['mentor'] = undefined;
    attrs['document'] = undefined;
    attrs['document_type'] = undefined;
    attrs['document_name'] = undefined;
    attrs['academic_year'] = undefined;
    attrs['activity_mentors'] = undefined;

    if (update) {
      attrs['group_time_slot'] = undefined;
      linkUpdate = linkUpdate + "/" + attrs['activity_id'];
      return this._db.post(linkUpdate, attrs);
    }
    return this._db.post(linkCreate, activitiesDto);
  }

  addIndividualContact(update = false) {
    return this.addIndividualActivity(update, API.CREATE_INDIVIDUAL_CONTACT, API.CREATE_ACTIVITIES);
  }
  addIndividualMentoring(update = false) {
    return this.addIndividualActivity(update, API.CREATE_INDIVIDUAL_MENTORING, API.CREATE_ACTIVITIES);
  }

    findAll(condition: any = {}, limit: number = 0, offset: number = 0) {
        if (!limit) {
            limit = 10;
        }
        if (!condition['$expand']) {
            condition['$expand'] = 'group,group/group_mentors/mentor,group/group_students/students';
        }
        return super.findAll(condition, limit, offset);
    }

    async findOneData(id: any, condition: any = {}) {
        var that = this;
        if (!condition['$expand']) {
            condition['$expand'] = 'school,group/group_mentors/mentor,group/group_students/students';
        }
        return await this._db.get(API.API_URL_COMMON + this.api_find_one + '/' + id + '/details/', condition);
    }

    deleteActivityStudent(activity_id, studentListHaveRemoved) {
      return this._db.post(API.API_URL_COMMON + 'activities/' + activity_id + '/remove_students', studentListHaveRemoved);
    }
}



// WEBPACK FOOTER //
// ./src/app/common/services/activities.service.ts